import { Dayjs } from "dayjs";
import { USER_ROLE, USER_TYPE } from "./userType";
import { SERVICE_CATEGORY } from "./serviceCategory";
export type ActionType = {
  type: string;
  payload: any;
};

// export class AuthModal {
//   firstName: string = "";
//   lastName: string = "";
//   title: string = "";
//   token: string = "";
//   email: string = "";
//   id: string = "";
//   userType: string = "";
//   phoneNumber: string = "";
//   profilePhoto: string = "";
//   addressLine1: string = "";
//   addressLine2: string = "";
//   city: string = "";
//   state: string = "";
//   pincode: string = "";
//   dateOfJoining: string = "";
//   isSessionValid: boolean | null = null;
// }
export class AuthModal {
  _id: string = "";
  email: string = "";
  firstName: string = "";
  lastName: string = "";
  phone: string = "";
  profilePhoto: string = "";
  role: USER_ROLE | string = "";
  token: string = "";
  isSessionValid: boolean | null = null;
}

export class LoginFormModal {
  phoneNumber: string = "";
  password: string = "";
}

export type APIResponseModal = {
  data: any;
  isSuccess: boolean;
  message: any;
};

// User_Management
export class UserListModal {
  total: number = 0;
  next: boolean = false;
  page: number = 1;
  limit: number = 10;
  result: UserData[] = [];
  search: string = "";
  sortedBy: string = "createdAt";
  sortOrder: string = "desc";
  fromDate: string = "";
  toDate: string = "";
  selectedValues: string[] = [];
  loader: boolean = false;
  showBlockPopup: boolean = false;
  toBlockId: string = "";
  status: number = 5;
  userStatus: number = 5;
  userType: USER_TYPE | number | string = USER_TYPE.CUSTOMER;
  UserId: string = "";
  reasonData: string[] = [];
  isVerified: string = "";
  isEditMode = false;
  pagination: Pagination = new Pagination();
}

export class Pagination {
  page: number = 1;
  limit: number = 10;
  totalPages: number = 1;
  totalRecords: number = 1;
}

export class SortBy {
  sortedBy: string = "";
  sortOrder: string = "";
}
export class UserData {
  id: string = "";
  _id: string = "";
  UserId: string = "";
  email: string = "";
  mobileNo?: string = "";
  phone?: string = "";
  phoneNumber?: string = "";
  fullName: string = "";
  firstName: string = "";
  lastName: string = "";
  gender: string = "";
  status: number = 0;
  createdAt?: string = "";
  bookingsCount: number = 0;
  city: string = "";
  profilePhoto: string = "";
  userDetail: UserDetailModal[] = [];
}

export class UserDetailModal {
  addressLine1: string = "";
  addressLine2: string = "";
  /** Form/API string for Home(0) / Work(1) / Other(2); empty when unset. */
  addressType: string = "";
  blocked = false;
  blockedAt: string = "";
  city: string = "";
  country: string = "";
  coordinates: number[] = [];
  dateOfJoining: string = "";
  document: string = "";
  role: USER_ROLE | string = "";
  fullName: string = "";
  firstName: string = "";
  lastName: string = "";
  mobileNo: string = "";
  servicePartnerListing: any[] = [];
  email: string = "";
  franchiseAmount: number = 0;
  gstNumber: string = "";
  id: string = "";
  createdAt?: string = "";
  numberOfStaff: number = 0;
  phoneNumber: string = "";
  pincode: string = "";
  registrationNumber: string = "";
  salary: number = 0;
  state: string = "";
  userType: string = "";
  loader = false;
  profilePhoto: string = "";
  password: string = "";
  confirmPassword: string = "";
}
export class PaymentDetailModal {
  discount: string = "";
  finalPrice: string = "";
  paymentStatus: string = "";
  servicePrice: string = "";
  tax: string = "";
}

export class CarTypesData {
  _id: string = "";
  total: number = 0;
  page: number = 1;
  limit: number = 10;
  carType: string = "";
  createdAt: string = "";
  updatedAt: string = "";
  isOpen?: boolean = false;
  loader: boolean = false;
  result: Result[] = [];
  allCarTypes: Result[] = [];
  pagination: Pagination = new Pagination();
  search: string = "";
}

export class CompanyDetails {
  id: number | string = -1;
  _id?: string = "";
  name: string = "";
  logo: string = "";
}

export class VehicleDetails {
  name: string = "";
  logo: string = "";
  vehicleType: string = "0";
  companyId: string = "";
  companyName: string = "";
  carTypeId: string = "";
  carCompany: CompanyDetails = new CompanyDetails();
  id: number = -1;
}

export class Result {
  _id: string = "";
  id: string = "";
  carType: string = "";
  /** Some API responses use `name` instead of `carType`. */
  name?: string = "";
  createdAt: string = "";
  updatedAt: string = "";
}

export class ServiceTypesData {
  _id: string = "";
  total: number = 0;
  page: number = 1;
  limit: number = 10;
  category: SERVICE_CATEGORY | number = SERVICE_CATEGORY.CAR;
  vehicleType: string = "0";
  serviceTime: string = "";
  description: string = "";
  serviceImage: string = "";
  serviceType: string = "";
  createdAt: string = "";
  updatedAt: string = "";
  isOpen?: boolean = false;
  loader: boolean = false;
  result: Result[] = [];
  pagination: Pagination = new Pagination();
}

/**
 * Form state for POST /api/v1/shinology/services/create-services.
 */
export class ServiceToolItem {
  _id?: string = "";
  title: string = "";
  image: string = "";
  previewUrl?: string = "";
  file?: File;
}

export class ServiceTitleDescriptionItem {
  _id?: string = "";
  title: string = "";
  description: string = "";
}

export class ServiceTypeFormData {
  category: SERVICE_CATEGORY | number = SERVICE_CATEGORY.CAR;
  title: string = "";
  serviceTime: string = "";
  imageKey: string = "";
  howItWorks: ServiceTitleDescriptionItem[] = [];
  requirementFromUser: ServiceToolItem[] = [];
  tools: ServiceToolItem[] = [];
  benefits: ServiceTitleDescriptionItem[] = [];
}

export class DiscountDetails {
  id: string = "";
  status: string = "1";
  endTime: string | any = "";
  startTime: string | any = "";
  discountValue: number = 0;
}
export class DiscountReducerModal {
  loader: boolean = false;
  pagination: Pagination = new Pagination();
  result: Array<DiscountDetails> = [];
}

export class ServicePricingModal {
  result: ServicePricingListModal[] = [];
  pagination: Pagination = new Pagination();
  loader: boolean = false;
  page: number = 1;
  limit: number = 10;
  category: SERVICE_CATEGORY | number = SERVICE_CATEGORY.CAR;
  categoryTypeId: string = "";
  categoryTypes: any[] = [];
}

export class AppPagination extends Pagination {
  sortedBy: string = "";
  sortOrder: string = "";
  search: string = "";
  serviceTypeId: string = "";
}
export interface OrderListItem {
  _id: string;
  orderId: string;
  userId: string;
  userName: string;
  paymentMode: number;
  price: number;
  orderStatus: number;
  service: string;
  createdAt: string;
}

export interface OrderDetails {
  id: string;
  _id?: string;
  orderId: string;
  price: string;
  dateTime: string;
  carType: CarType;
  createdAt: string;
  paymentType: string;
  orderStatus: string;
  user: UserDetailModal;
  cancelledByUser: any;
  cancellationReason: any;
  serviceType: ServiceType;
  merchant: UserDetailModal;
  createdBy: UserDetailModal;
  carRegistrationNumber: string;
  payment: PaymentDetailModal;
}

export interface CarType {
  id: number;
  carType: string;
}

export interface ServiceType {
  id: number;
  serviceType: string;
}

export class OrderList {
  isLoading: boolean = false;
  result: OrderListItem[] = [];
  sortedBy: string = "";
  sortOrder: string = "";
  search: string = "";
  serviceTypeId: string = "";
  page: number = 1;
  limit: number = 10;
  totalPages: number = 1;
  totalRecords: number = 1;
}

export class CreateOrder {
  userList: Array<UserDetailModal> = [];
  serviceTypeList: Array<ServiceType> = [];
  merchantList: Array<UserDetailModal> = [];
  carTypeList: Array<CarType> = [];
  serviceCategoryList: Array<ServiceCategoryModal> = [];
  serviceList: Array<ServiceModal> = [];
}

export class CurrentDiscount {
  discountValue: number = 0;
}
export class OrderManagementReducerModal {
  isLoading: boolean = false;
  result: OrderListItem[] = [];
  sortedBy: string = "createdAt";
  sortOrder: string = "desc";
  search: string = "";
  serviceTypeId: string = "-1";
  page: number = 1;
  limit: number = 10;
  totalRecords: number = 1;
  totalPages: number = 1;
  orderStatus: string = "-1";
  createOrder: CreateOrder = new CreateOrder();
  serviceTypesList: any[] = [];
  paymentType: string = "-1";
  userId: string = "";
  merchantId: string = "";
  category: string = "-1";
  selectedUser: UserDetailModal | null = null;
  selectedMerchant: UserDetailModal | null = null;
  currentDiscount: CurrentDiscount = new CurrentDiscount();
  serviceCategoryList: Array<ServiceCategoryModal> = [];
}

export class ServicePricingListModal {
  id: string = "";
  price: string | number = "";
  createdAt?: string = "";
  serviceDuration: string = "";
  carType: CarTypeData = new CarTypeData();
  serviceType: string | ServiceTypeData = "";
}

export class CarTypeData {
  id: string = "";
  carType: string = "";
  createdAt: string = "";
  updatedAt: string = "";
}

export class ServiceTypeData {
  id: string = "";
  serviceType: string = "";
  createdAt: string = "";
  updatedAt: string = "";
}

export class MetaData {
  bookingDate: string = "";
  bookingRef: string = "";
  bookingType: string = "";
  slotEndTime: string = "";
  slotStartTime: number = 0;
  vendorId: number = 0;
}

export class AdminDetails {
  name: string = "";
  _id: string = "";
}

export class StatusFilterModal {
  label: string = "";
  value: string = "";
}

export class BookingVsTipsEarningModal {
  totalTipEarning: number = 0;
  totalBookingEarning: number = 0;
  month: string = "";
}

export class NotificationsListModal {
  total: number = 0;
  next: boolean = false;
  page: number = 1;
  limit: number = 10;
  result: NotificationListData[] = [];
  search: string = "";
  sortedBy: string = "";
  sortOrder: string = "";
  selectedValues: string[] = [];
  loader = false;
  showDeletePopup: boolean = false;
  toDeleteId: string = "";
  fromDate: Dayjs | null = null;
  toDate: Dayjs | null = null;
  filterStatus: string = "";
}

export class NotificationListData {
  _id: string = "";
  title: string = "";
  date: string = "";
  sentTo: string = "";
  status: number = 0;
}

export class NotificationDetailModal {
  _id: string = "";
  not_idToEdit: string = "";
  senderId: string = "";
  receiverIds: string[] = [];
  image: string = "";
  title: string = "";
  description: string = "";
  notificationType: number = 0;
  recipientType: number = 0;
  isSent: boolean = false;
  status: number = 0;
  createdAt: string = "";
  loader: boolean = false;
  subject: string = "";
  editMode: boolean = false;
}

export enum ORDER_PAYMENT_TYPE {
  COD_ONLINE = "0",
  ONLINE = "1",
  COD_CASH = "2",
}
export class CarCompany {
  id: string = "";
  _id: string = "";
  logo: string = "";
  name: string = "";
  company: string = "";
  /** Legacy / alternate API id field. */
  companyId?: string = "";
  /** Legacy / alternate API name field. */
  brandName?: string = "";
  createdAt?: string = "";
}

class CarCompanyList {
  isLoading: boolean = false;
  result: Array<CarCompany> = [];
  sortedBy: string = "";
  sortOrder: string = "";
  pagination: Pagination = new Pagination();
  search: string = "";
}

class VehicleCompanyList {
  isLoading: boolean = false;
  result: Array<CarCompany> = [];
  sortedBy: string = "";
  sortOrder: string = "";
  pagination: Pagination = new Pagination();
  search: string = "";
}

export class CarCompanyReducerModal {
  carCompanies: CarCompanyList = new CarCompanyList();
  vehicles: VehicleCompanyList = new VehicleCompanyList();
}
export interface Card {
  installments: any;
  mandate_options: any;
  network: any;
  request_three_d_secure: string;
}

export type DistinctCarTypeCountType = {
  orderCount: string;
  carType: {
    carType: string;
  };
};

export type DistinctServiceTypeCountType = {
  orderCount: string;
  serviceType: {
    serviceType: string;
    serviceImage: string;
  };
};

export type UsersByTypeCountType = {
  userType: string;
  userCount: string;
};

export type DashboardDataType = {
  successOrder: number;
  totalRevenue: number;
  totalComplaints: number;
  totalUsersCount: number;
  canceledByCustomer: number;
  canceledByMerchant: number;
  unresolvedComplaints: number;
  usersByTypeCount: UsersByTypeCountType[];
  distinctCarTypeCount: DistinctCarTypeCountType[];
  distinctServiceTypeCount: DistinctServiceTypeCountType[];
};

export class TestimonialData {
  _id: string = "";
  id: string = "";
  category: SERVICE_CATEGORY | number = SERVICE_CATEGORY.CAR;
  media: string = "";
  mediaPreview: string = "";
  thumbnail: string = "";
  thumbnailPreview: string = "";
  title: string = "";
  createdAt: string = "";
  updatedAt: string = "";
}

export class TestimonialFormData {
  category: SERVICE_CATEGORY | number = SERVICE_CATEGORY.CAR;
  title: string = "";
  thumbnailFile: File | null = null;
  existingThumbnailUrl: string = "";
  mediaFile: File | null = null;
  existingMediaUrl: string = "";
}

export class TestimonialReducerModal {
  result: TestimonialData[] = [];
  page: number = 1;
  limit: number = 6;
  total: number = 0;
  totalPages: number = 1;
  nextHit: boolean = false;
  category: SERVICE_CATEGORY | number = SERVICE_CATEGORY.CAR;
  loader: boolean = false;
  pagination: Pagination = Object.assign(new Pagination(), {
    limit: 6,
    totalRecords: 0,
  });
}

export class CouponListItem {
  _id: string = "";
  id: string = "";
  couponCode: string = "";
  title: string = "";
  description: string = "";
  couponName: string = "";
  image: string = "";
  imagePreview: string = "";
  bannerImage: string = "";
  couponType: string = "";
  categories: number[] = [];
  category: number[] = [];
  couponValue: number = 0;
  isPercentage: boolean = false;
  percentageOff: number = 0;
  couponLevelRedemption?: number | null;
  userLevelRedemption?: number | null;
  reedemedCouponCount?: number | null;
  startTime: string = "";
  endTime: string = "";
  startDate: string = "";
  endDate: string = "";
  status: number = 0;
  isDefault: boolean = false;
  createdOn: string = "";
  createdAt: string = "";
  updatedAt: string = "";
}

export class CouponReducerModal {
  isLoading: boolean = false;
  details: any = null;
  result: CouponListItem[] = [];
  sortedBy: string = "createdAt";
  sortOrder: string = "desc";
  search: string = "";
  couponType: string = "-1";
  category: string = "-1";
  status: string = "-1";
  page: number = 1;
  limit: number = 10;
  totalRecords: number = 0;
  totalPages: number = 1;
}

// Reducer Model
export type ReducersModal = {
  AuthReducer: AuthModal;
  UserReducer: UserListModal;
  UserDetailReducer: UserDetailModal;
  CarsTypeReducer: CarTypesData;
  ServiceTypeReducer: ServiceTypesData;
  ServicePricingListReducer: ServicePricingListModal;
  ServicePricingReducer: ServicePricingModal;
  OrderManagementReducer: OrderManagementReducerModal;
  CarCompanyReducer: CarCompanyReducerModal;
  DiscountReducer: DiscountReducerModal;
  TestimonialReducer: TestimonialReducerModal;
  CouponReducer: CouponReducerModal;
};

export class ServiceCategoryModal {

  _id: string = "";
  categoryName: string = "";
  logo: string = "";
  type?: string = "";

}


export class ServiceModal {
  _id: string = "";
  serviceName: string = "";
  serviceTime: string = "";
  servicePriceId: string = "";
  price: number = 0;
  createdOn: string = "";
  benefits: string[] = [];
  image: string = "";
}

export type AddressItem = {
  _id: string;
  firstName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  pincode?: string;
  isDefault?: boolean;
  /** 0 Home, 1 Work, 2 Other. Absent on older saved addresses. */
  addressType?: number | string;
  location?: {
    type?: string;
    coordinates?: (number | string)[];
  };
};
